import { useEffect } from "react";
import { useSelector } from "react-redux";
import store from "../../stores/store";
import { getLayerParams, setLayerTimeDimension } from "../map/mapUtils";
import moment from "moment";
import { trans } from "../../lib/utils";

function TimeDimensionDropdown(props) {
  const layers = useSelector((state) => store.getState().layers);
  const timeDimension = useSelector((state) => store.getState().timeDimension);

  useEffect(() => {}, []);

  return (
    <div className="d-flex">
      <select
        className="form-select form-select-sm "
        value={timeDimension.currentDimension}
        onChange={(e) => {
          if (props.onChange) {
            props.onChange(e);
          }

          store.dispatch({
            type: "timeDimension/goto",
            payload: e.target.value,
          });
        }}
      >
        {Object.keys(props.dimensions)?.map((el) => {
          let time = props.dimensions[el];
          return (
            <option value={time}>
              {moment(time).format("ddd DD MMMM YYYY HH:mm")}
            </option>
          );
        })}
      </select>
      <div
        className="border pe-2 ps-2"
        role="button"
        onClick={() => {
          // let layer = layers[props.layer.id];
          // let dimensionStatus = layer?.["dimensionStatus"]
          //   ? layer["dimensionStatus"]
          //   : false;
          // if (!dimensionStatus) {
          //   store.dispatch({
          //     type: "layer/update",
          //     payload: {
          //       id: layer.id,
          //       property: "dimensionStatus",
          //       value: setInterval(function () {
          //         let layer = layers[props.layer.id];
          //         let timeIndex = layer.dimensions.indexOf(
          //           getLayerParams(layer, "TIME")
          //         );
          //         let time = props.value;
          //         if (timeIndex + 1 > props.dimensions.length - 1) {
          //           time = props.dimensions[0];
          //         } else if (timeIndex < 0) {
          //           time = props.dimensions[0];
          //         } else {
          //           time = props.dimensions[timeIndex + 1];
          //         }
          //         store.dispatch({
          //           type: "layer/update",
          //           payload: {
          //             id: layer.id,
          //             property: "defaultDimension",
          //             value: time,
          //           },
          //         });
          //         setLayerTimeDimension(layer, time);
          //       }, 1000),
          //     },
          //   });
          // } else {
          //   clearInterval(layer["dimensionStatus"]);
          //   store.dispatch({
          //     type: "layer/update",
          //     payload: {
          //       id: layer.id,
          //       property: "dimensionStatus",
          //       value: null,
          //     },
          //   });
          // }
          store.dispatch({ type: "timeDimension/toggleplay" });
        }}
      >
        <div className="m-auto pt-1 small">
          {window["timeDimension"] ? (
            <>
              <i className="fas fa-pause me-2 small"></i> {trans("Pause")}
            </>
          ) : (
            <>
              <i className="fas fa-play me-2 small"></i> {trans("Play")}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default TimeDimensionDropdown;
